import {
  revalidateUser,
  useCurrentUser,
} from '@kanda-libs/ks-frontend-services';
import { useAppDispatch } from 'hooks';
import { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { selectors } from 'store';

export interface GhostBannerHook {
  email: string;
  name?: string;
  visible: boolean;
}

export default function useGhostBanner(): GhostBannerHook {
  const { user, isUserLoggedIn } = useCurrentUser();
  const { isGhosted } = useSelector(selectors.getPathKey);
  const dispatch = useAppDispatch();

  const timerRef = useRef<NodeJS.Timer | null>(null);
  useEffect(() => {
    if (!isUserLoggedIn) return () => {};
    timerRef.current = setInterval(() => dispatch(revalidateUser()), 20000);
    return () => {
      clearTimeout(timerRef.current as unknown as number);
    };
  }, [isUserLoggedIn, dispatch]);

  const email = useMemo(() => {
    if (!user || !user?.email) return 'invalid';
    return user.email;
  }, [user]);

  const name = useMemo(() => {
    if (!user || !user?.displayName) return undefined;
    return user.displayName;
  }, [user]);

  return {
    email,
    name,
    visible: isGhosted,
  };
}
